import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import ImovelButtonGroup from "../imovelButtonGroup";
import UserInfo from "../../../UserInfo";
import api from "../../../api-axios";
import { LoadIndicator } from "devextreme-react/load-indicator";

const template = {
  _uiCarregando: true,
  tipoCalculoIptu: undefined,
  cotaVvt: undefined,
  cotaVve: undefined,
  valorIptu: undefined,
};

export default class CalculoIptu extends React.Component {
  constructor(props) {
    super(props);
    console.log("props calculoiptu", props);
    this.state = { ...template, imovelId: props.match.params.id };

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);

    this.tipoCalculoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Selecione...",
      dataSource: [
        { id: 0, descricao: "Automático" },
        { id: 1, descricao: "Manual" },
        { id: 2, descricao: "Manual sem distribuir valores" },
        { id: 3, descricao: "Arbitrado por Valor Venal" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    api
      .get(`/imoveis/opcoescalculo/${this.state.imovelId}`)
      .then(resp => {
        console.log("Dados cálculo:", resp);
        this.setState({ ...resp.data, _uiCarregando: false });
      })
      .catch(error => {
        notify(error.message, "error");
        this.props.history.goBack();
      });
  }

  render() {
    
    if (this.state._uiCarregando) {
      return (
        <div className={"content-block dx-card responsive-paddings"}>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <LoadIndicator width={60} height={60} />
          </div>
        </div>
      );
    }



    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <ImovelButtonGroup props={this.props} />
          <Form formData={this.state} colCount={2}>
            <GroupItem caption="Cálculo do IPTU" colSpan={2} colCount={1}>
              <SimpleItem
                dataField={"tipoCalculoIptu"}
                editorType={"dxSelectBox"}
                editorOptions={this.tipoCalculoOptions}
                colSpan={2}
              >
                <Label text="Tipo de Cálculo" />
              </SimpleItem>
            </GroupItem>


            <GroupItem caption="Divisão do  Valor Venal (não recomendado)">

              <SimpleItem dataField={"cotaVvt"} editorType={"dxNumberBox"}
                cssClass="box-n2"
                editorOptions={{
                  format: { type: "fixedPoint", precision: 2 },
                  showClearButton: true
                }} helpText={"Se 'Cota VVE' + 'Cota VVT' diferente do valor vanel, é tratado como cota parte do valor"}>
                <Label text="% Cota VVT" />
              </SimpleItem>


              <SimpleItem dataField={"cotaVve"} editorType={"dxNumberBox"}
                cssClass="box-n2"
                editorOptions={{
                  format: { type: "fixedPoint", precision: 2 },
                  showClearButton: true
                }} helpText={"Se 'Cota VVE' + 'Cota VVT' diferente do valor vanel, é tratado como cota parte do valor"}>
                <Label text="% Cota VVE" />
              </SimpleItem>
            </GroupItem>


            <GroupItem caption="Apuração IPTU">

              <SimpleItem dataField={"valorVenal"} editorType={"dxNumberBox"}
                cssClass="box-n2"
                editorOptions={{
                  format: { type: "fixedPoint", precision: 2 },
                  showClearButton: true
                }} helpText={"Se o tipo de arbitramento não citar 'Valor Venal' então esse campo é desconsiderado e o 'Valor Venal' calculado a partir de 'Valor IPTU' dividido pela 'Alíquota'"}>
                <Label text="Valor Venal (R$)" />
              </SimpleItem>

              <SimpleItem dataField={"aliquota"} editorType={"dxNumberBox"}
                cssClass="box-n2"
                editorOptions={{
                  format: { type: "fixedPoint", precision: 2 },
                  showClearButton: true
                }} helpText={"Se o tipo de arbitramento não citar 'Alíquota' então esse campo é desconsiderado e a 'Alíquota' obtida pelas configurações de IPTU"}>
                <Label text="Aliquota (%)" />
              </SimpleItem>

              <SimpleItem dataField={"valorIptu"} editorType={"dxNumberBox"}
                cssClass="box-n2"
                editorOptions={{
                  format: { type: "fixedPoint", precision: 2 },
                  showClearButton: true
                }} helpText={"É 'Valor IPTU' gerado, porém caso o tipo de arbitramento selecionado seja por 'Valor Venal' este campo é desconsiderado."}>
                <Label text="Valor IPTU" />
              </SimpleItem>
            </GroupItem>

          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Voltar"
                type="warn"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    console.log(entidade);

    api
      .put("/imoveis/opcoescalculo", entidade)
      .then(_ => {
        notify("Dados salvos com sucesso", "success");
      })
      .catch(error => {
        notify(error.message, "error");
      })
      .finally(() => {
        this.props.history.goBack();
      })

  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
